import ApiService from "@/core/services/api.service";
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const OPTIONSLIST = "optionsList";
export const SETOPTIONSLIST = "setOptionsList";
export const UPFILE = "upfile";


const state = {
    optionsList: {}
};


const actions = {
    [OPTIONSLIST]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-config/web/DictData/findAllByList`, o, { type: 'listjson' }).then((res) => {
            for (var i in res) {
                res[i] = res[i].map(j => {
                    return {
                        ...j,
                        value: j.dictValue,
                        text: j.dictLabel
                    }
                })
            }
            console.log(res)
            commit(SETOPTIONSLIST, res)
        });
    },
    [UPFILE]({ commit }, o) {
        console.log(commit)
        return  ApiService.post2(`/zb/api-file/files-anon`, o,{type:'file'})

    },

};
const mutations = {
    [SETOPTIONSLIST](state, data) {
        state.optionsList = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
